import { PAGEURL } from "helpers/constant";
import { callApi } from "Apis";

export async function pagesList(data) {
  try {
    const response = await callApi({ url: PAGEURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
